import { render, staticRenderFns } from "./ChartBarComponent.vue?vue&type=template&id=74d6d142&"
import script from "./ChartBarComponent.vue?vue&type=script&lang=js&"
export * from "./ChartBarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports